import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { HubDiagram } from './HubDiagram';
import { AvailabilityForm } from './AvailabilityForm';
export function Hero() {
  const [formOpen, setFormOpen] = useState(false);
  return <section className="flex flex-1 items-center bg-white" data-id="element-34" data-mp="4mi2n8mfxkdf">
      <div className="mx-auto grid w-full max-w-7xl items-center gap-12 px-6 py-12 lg:grid-cols-[1.15fr_1fr] lg:gap-16" data-id="element-35" data-mp="4jvv38zjv4v7">
        <div data-id="element-36" data-mp="xanpc0x21jfw">
          <h1 className="font-display text-5xl font-bold leading-[0.98] tracking-tight text-ink sm:text-6xl lg:text-[4.5rem]" data-id="element-37" data-mp="xa4h5bx7i9f2">
            The system that runs our team.{' '}
            <span className="text-brand" data-id="element-38" data-mp="nc858hwg3afw">Coming soon to yours.</span>
          </h1>
          <p className="mt-6 max-w-lg text-lg leading-relaxed text-ink-muted" data-id="element-39" data-mp="nekmstyajisf">
            Built by agents, for agents. Now opening to select teams and brokerages.
          </p>

          <div className="mt-9 max-w-lg" data-id="element-40" data-mp="3814alm6t1smr">
            <AnimatePresence mode="wait" initial={false} data-id="element-41" data-mp="3j8sfs1yzrlqd">
              {formOpen ? <motion.div key="form" initial={{
              opacity: 0,
              y: 6
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-42" data-mp="3o7lq5lizewmb">
                  <AvailabilityForm data-id="element-43" data-mp="3e84mf9naissz" />
                </motion.div> : <motion.button key="cta" type="button" onClick={() => setFormOpen(true)} exit={{
              opacity: 0,
              scale: 0.98
            }} transition={{
              duration: 0.15,
              ease: [0.23, 1, 0.32, 1]
            }} className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-brand px-7 py-3.5 text-base font-semibold text-white transition-colors duration-150 hover:bg-brand-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2" data-id="element-44" data-mp="30gzuyuu2t6tq">
                  Check availability in your area
                  <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-45" data-mp="s3ur9xru3ab5" />
                </motion.button>}
            </AnimatePresence>
          </div>
        </div>

        <HubDiagram data-id="element-46" data-mp="ichz1524ii4l" />
      </div>
    </section>;
}